import { render } from "./admin-support-list.vue?vue&type=template&id=6bda177e"
import script from "./admin-support-list.vue?vue&type=script&lang=js"
export * from "./admin-support-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__